import { normalizeVideo } from './normalizeVideo';
export const modelizeVideo = article => ({
  title: article.title,
  subtitle: article.body.metadata.description,
  video: normalizeVideo(article.body.url),
  date: article.revision.created ?? null
});